<template>
  <listing-layout>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h2 mb-0">Admin Users</h1>
      <router-link tag="button" :to="{ name: 'Add Admin Members' }"
        class="btn btn-primary d-md-none px-xl-5 mt-2 mt-sm-0">Add<span class="d-none d-sm-inline">
          Admin</span></router-link>
    </div>
    <div slot="content">
      <div class="alert alert-warning" v-if="error">{{ error }}</div>
      <div class="alert alert-success" v-if="success">{{ success }}</div>
      <data-table :dataRows="rows" :dataColumns="columns" :options="options">
        <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.first_name + ' ' + row.last_name"
          :link="'Admin Profile'" :row="row" :options="{ showLinks: true, expandMobile: true }" />
        <div slot-scope="{ row }" slot="expandedRow">
          <ul class="list-unstyled mb-0 pt-2">
            <li>
              <strong>Phone: </strong>
              <tableTextTemplate :text="row.attributes ? row.attributes.phone : null" :row="row"
                :options="{ inline: true }" />
            </li>
          </ul>
        </div>
      </data-table>
    </div>
  </listing-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import axios from 'axios'
import listingLayout from '@/components/ListingLayout'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'

export default {
  name: 'AdminUsers',
  props: ['success'],
  components: {
    'listing-layout': listingLayout,
    'data-table': dataTable,
    tableTextTemplate
  },
  data() {
    return {
      error: '',
      rows: [],
      columns: [
        {
          label: 'First Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.first_name" :link="'Admin Profile'" :row="row" :options="{ showLinks: true }" />`
          }),
          representedAs(row) { return `${row.first_name}` }
        },
        {
          label: 'Last Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.last_name" :link="'Admin Profile'" :row="row" :options="{ showLinks: true }" />`
          }),
          representedAs(row) { return `${row.last_name}` }
        },
        {
          label: 'Phone',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.attributes?.phone" :row="row" />`
          })
        }
      ],
      options: {
        search: true,
        addAdmin: this.$isAdmin
      }
    }
  },
  mounted() {
    axios.get(`${this.$api}/admin/admin-list`).then((response) => {
      if (response.data.status === 'success') {
        this.error = ''
        this.rows = response.data.data
      } else {
        this.error = 'Unable to receive data from the server. Please reload the page.'
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Listing/AdminUsers.vue